import React from 'react';
import I18n from 'i18n-js';
import SessionPopup from '@/components/common/SessionPopup';
import Icon from '@/components/ui/Icon';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

// AIDEV-NOTE: PLAT-16829 — Shown to students after the teacher ends a Teacher-Paced Mode
// session. Dismissable via X, overlay click, or the Close button; dismissing returns them
// to the normal self-paced slideshow.
const SessionEndedPopup = ({ isOpen, onClose }: Props) => (
  <SessionPopup
    body={I18n.t('session_ended_body')}
    headline={{
      id: 'session-ended-headline',
      text: I18n.t('session_ended_headline'),
    }}
    icon={<Icon icon="InfoAlternate" size={30} />}
    isOpen={isOpen}
    primaryButton={{
      onClick: onClose,
      text: I18n.t('session_ended_close_button'),
    }}
    onClose={onClose}
  />
);

export default SessionEndedPopup;
